const MOIS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

export const frDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${parseInt(d, 10)} ${MOIS[parseInt(m, 10) - 1]} ${y}`;
};

// Accepte 'AAAA-MM-JJ' ou 'JJ/MM/AAAA' (périodes d'arrêté)
export const frDateAny = (s) => {
  if (!s) return "";
  if (s.includes("/")) {
    const [d, m, y] = s.split("/");
    return `${parseInt(d, 10)} ${MOIS[parseInt(m, 10) - 1]} ${y}`;
  }
  return frDate(s);
};
